import { SvgIconProps } from '@mui/material'
import * as React from 'react'

function Pencil({ fill, ...props }) {
  return (
    <svg
      width={27}
      height={27}
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.375 19.407v4.218h4.219l12.442-12.442-4.219-4.219L3.376 19.407zM23.299 7.92a1.12 1.12 0 000-1.586l-2.633-2.632a1.12 1.12 0 00-1.586 0L17.021 5.76 21.24 9.98l2.059-2.059z"
        fill={fill}
      />
    </svg>
  )
}

export default Pencil
